export default __webpack_public_path__ + "static/media/PinkCirclePaywall.67c7c3cd.svg";